(function(){
"use strict";
var PROJECT_URL="https://ycentdpkspjdrzijrbsl.supabase.co";
var API_KEY="sb_publishable_TgKotXn3vvPpdnad_wXc9g_X1DY7arT";
var STORAGE_KEY="sb-ycentdpkspjdrzijrbsl-auth-token";
var busy=false,lastToken="";

function authToken(){
  try{
    var raw=localStorage.getItem(STORAGE_KEY);
    if(!raw)return null;
    var v=JSON.parse(raw);
    return v&&v.access_token?v.access_token:null;
  }catch(e){return null;}
}
function sellerToken(){
  var h=location.hash.split("?")[0];
  return h.indexOf("#/s/")===0?decodeURIComponent(h.slice(4)):"";
}
async function rpcShare(token){
  var t=authToken(); if(!t)return null;
  var r=await fetch(PROJECT_URL+"/rest/v1/rpc/get_member_share_v27",{
    method:"POST",
    headers:{"apikey":API_KEY,"Authorization":"Bearer "+t,"Content-Type":"application/json"},
    body:JSON.stringify({p_token:token})
  });
  if(!r.ok)return null;
  return await r.json();
}
function removeBanner(){
  var b=document.getElementById("kp-seller-preview-banner");if(b)b.remove();
  document.querySelectorAll("[data-kp-preview-disabled]").forEach(function(btn){
    btn.disabled=false;btn.removeAttribute("data-kp-preview-disabled");
    if(btn.dataset.kpOldText){btn.textContent=btn.dataset.kpOldText;delete btn.dataset.kpOldText;}
  });
}
function applyPreview(info){
  if(!info||!info.preview)return;
  var main=document.querySelector("main");
  if(!main)return;
  if(!document.getElementById("kp-seller-preview-banner")){
    var box=document.createElement("div");
    box.id="kp-seller-preview-banner";
    box.className="kp-seller-preview-banner";
    box.innerHTML='<b>Förhandsvisning</b><span>Den här kampanjen är inte publik just nu. Bara du/behörig gruppansvarig kan se denna förhandsvisning. Beställningar är avstängda här.</span>';
    main.insertAdjacentElement("afterbegin",box);
  }
  document.querySelectorAll(".js-order-product").forEach(function(btn){
    if(!btn.dataset.kpPreviewDisabled){
      btn.dataset.kpPreviewDisabled="1";
      btn.dataset.kpOldText=btn.textContent||"Beställ";
      btn.disabled=true;
      btn.textContent="Förhandsvisning";
    }
  });
}
async function sync(){
  var token=sellerToken();
  if(!token){lastToken="";removeBanner();return;}
  if(busy)return;
  busy=true;
  try{
    var info=await rpcShare(token);
    if(sellerToken()!==token)return;
    if(info&&info.preview)applyPreview(info);else removeBanner();
    lastToken=token;
  }catch(e){}finally{busy=false;}
}
window.addEventListener("hashchange",function(){setTimeout(sync,350);});
var app=document.getElementById("app");
if(app&&window.MutationObserver)new MutationObserver(function(){if(sellerToken())setTimeout(sync,180);}).observe(app,{childList:true,subtree:true});
setTimeout(sync,650);
})();